import React from 'react';
import PropTypes from 'prop-types';
import equal from 'fast-deep-equal';
import HeatmapCellDividers from 'components/heatmap-cell-dividers';
import HeatmapRow from 'components/heatmap-row';
import styles from './index.css';

export default class HeatmapRows extends React.Component {
  static propTypes = {
    columnWidth: PropTypes.number,
    contentWidth: PropTypes.number,
    height: PropTypes.number,
    rowHeight: PropTypes.number,
    rows: PropTypes.array,
    x: PropTypes.number,
    y: PropTypes.number,
  };

  static defaultProps = {
    columnWidth: 0,
    contentWidth: 0,
    rowHeight: 0,
    rows: [],
    x: 0,
    y: 0,
  };

  shouldComponentUpdate(nextProps) {
    return !equal(this.props, nextProps);
  }

  render() {
    return (
      <g
        className={styles.HeatmapRows}
        transform={`translate(${this.props.x} ${this.props.y})`}>
        {this.props.rows.map((day, index) => (
          <HeatmapRow
            columnWidth={this.props.columnWidth}
            day={day}
            height={this.props.rowHeight}
            key={`heatmapRow${index}`}
            width={this.props.contentWidth}
            y={this.props.rowHeight * index}
          />
        ))}

        <HeatmapCellDividers
          columnWidth={this.props.columnWidth}
          height={this.props.height}
        />
      </g>
    );
  }
}
